var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px",
      "label-suffix": ":",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号类型",
      "prop": "userType"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": !!_vm.user
    },
    model: {
      value: (_vm.form.userType),
      callback: function($$v) {
        _vm.$set(_vm.form, "userType", $$v)
      },
      expression: "form.userType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "政府账号",
      "value": 1
    }
  }), _c('el-option', {
    attrs: {
      "label": "内部账号",
      "value": 2
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "filterable"
    },
    model: {
      value: (_vm.form.role_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "role_id", $$v)
      },
      expression: "form.role_id"
    }
  }, _vm._l((_vm.roleList), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.roleDescription,
        "value": city.id
      }
    })
  }))], 1), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "userName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "174px"
    },
    attrs: {
      "disabled": !!_vm.user
    },
    model: {
      value: (_vm.form.userName),
      callback: function($$v) {
        _vm.$set(_vm.form, "userName", $$v)
      },
      expression: "form.userName"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('span', [_vm._v("系统自动生成")])]), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(("确认" + (_vm.user ? '修改' : '开通'))))])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7f799310", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f799310","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/userForm.vue
// module id = d6Wi
// module chunks = 1